module.exports = __webpack_public_path__ + "img/supercar.f26d314d.jpg";